// /*
// createImageUrl(
//   {
//     illustration: ?String,
//     imageUrl: ?String,
//   },
//   theme,
//   currentLanguage,
// );

//   Returns a painbtrush URL if an illustration is provided,
//   otherwise returns a static imageUrl
// */

import { createPaintbrushUrl } from '@uds/illustrations';
import { isNotNilOrEmpty } from '@team-griffin/capra';
import * as r from 'ramda';
import urlLanguageParse from 'presentation/utils/urlLanguageParse';
import { Theme } from '@uds/theme-utils';

const hasIllustration = r.propSatisfies(isNotNilOrEmpty, 'illustration');

export default (
  media: {
    illustration: string | undefined;
    imageUrl: string | undefined;
  },
  theme: Theme,
  currentLanguage?: string,
) =>
  r.ifElse(
    hasIllustration,
    () =>
      createPaintbrushUrl(
        media.illustration ?? '',
        // @ts-ignore: mismatching types after upgrade
        theme,
      ),
    () => urlLanguageParse(media.imageUrl ?? '', currentLanguage ?? ''),
  )(media);
